import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import resumePDF from '../assets/SABARISAN.pdf';
import { trackDownload, trackButtonClick } from '../utils/analytics';

const Header = () => {
  const [activeSection, setActiveSection] = useState('about');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleResumeClick = () => {
    trackDownload('Sabarisan_Resume.pdf');
    window.open(resumePDF, '_blank');
  };

  const scrollToSection = (sectionId) => {
    trackButtonClick(`Navigate to ${sectionId}`);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
      setActiveSection(sectionId);
      setIsMenuOpen(false);
    }
  };

  const handleGymAppClick = () => {
    trackButtonClick('Gym Management App');
    navigate('/gym-management');
  };

  // Track active section on scroll
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'about', 'skills', 'experience', 'services', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'hero', label: 'Home' },
    { id: 'about', label: 'About me' },
    { id: 'skills', label: 'Skills' },
    { id: 'experience', label: 'Experience' },
    { id: 'services', label: 'Services' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <header className="bg-[#1c1d22] text-white p-4 shadow-lg fixed w-full top-0 z-50 backdrop-blur-sm bg-opacity-95">
      <div className="flex justify-between items-center max-w-7xl mx-auto">
        {/* Logo and title */}
        <div className="cursor-pointer" onClick={() => scrollToSection('hero')}>
          <h1 className="text-2xl font-bold hover:text-pink-400 transition-colors">Sabarisan P</h1>
          <p className="text-sm">Front End Developer • Chennai, India</p>
        </div>

        {/* Mobile menu button */}
        <button 
          className="md:hidden text-white focus:outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>

        {/* Desktop Navigation menu */}
        <ul className="hidden md:flex font-bold space-x-6 text-sm text-gray-300">
          {navItems.map((item) => (
            <li 
              key={item.id}
              className={`cursor-pointer transition-all pb-1 relative ${
                activeSection === item.id 
                  ? 'text-pink-400' 
                  : 'hover:text-pink-400'
              }`}
              onClick={() => scrollToSection(item.id)}
            >
              {item.label}
              {activeSection === item.id && (
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full"></span>
              )}
            </li>
          ))}
          <li 
            className="cursor-pointer hover:text-pink-400 transition-colors"
            onClick={handleResumeClick}
          >
            Resume
          </li>
          <li 
            className="cursor-pointer hover:text-yellow-400 transition-colors bg-gradient-to-r from-purple-600 to-pink-600 px-3 py-1 rounded-lg hover:from-purple-700 hover:to-pink-700 transform hover:scale-105"
            onClick={handleGymAppClick}
          >
            🏋️ Gym App
          </li>
        </ul>

        {/* Mobile Navigation menu */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 w-full bg-[#1c1d22] md:hidden shadow-lg border-t border-purple-900/30">
            <ul className="flex flex-col space-y-4 p-4 text-sm text-gray-300">
              {navItems.map((item) => (
                <li 
                  key={item.id}
                  className={`cursor-pointer transition-colors pl-4 py-2 rounded-lg ${
                    activeSection === item.id 
                      ? 'text-pink-400 bg-purple-900/30 border-l-4 border-pink-500' 
                      : 'hover:text-pink-400 hover:bg-purple-900/20'
                  }`}
                  onClick={() => scrollToSection(item.id)}
                >
                  {item.label}
                </li>
              ))}
              <li 
                className="cursor-pointer hover:text-pink-400 transition-colors pl-4 py-2 rounded-lg hover:bg-purple-900/20"
                onClick={handleResumeClick}
              >
                Resume
              </li>
              <li 
                className="cursor-pointer hover:text-yellow-400 transition-colors bg-gradient-to-r from-purple-600 to-pink-600 px-3 py-2 rounded-lg text-center hover:from-purple-700 hover:to-pink-700"
                onClick={handleGymAppClick}
              >
                🏋️ Gym Management App
              </li>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;